import { takeLatest, call, put, select } from 'redux-saga/effects';
import axiosInstance from '../../services/AuthHeader';
import { setSending, unsetSending } from '../reducers/serverCommunication';
import {
  clearProfileFailure,
  selectUserId,
  setProfile,
  setProfileFailure,
} from '../reducers/session';

export const SAGA_GET_PROFILE = 'SAGA_GET_PROFILE';

export function sendGetProfile() {
  return { type: SAGA_GET_PROFILE };
}

const handleGetProfile = async ({ userId }) =>
  axiosInstance.get('/api/users/' + userId + '/profile').then((res) => res.data);

export function* getProfile() {
  yield put(setSending);
  // Clear any errors.
  yield put(clearProfileFailure());
  try {
    let userId = yield select(selectUserId);
    const response = yield call(handleGetProfile, { userId });
    yield put(setProfile(response.profile));
  } catch (error) {
    yield put(setProfileFailure(error.response));
  } finally {
    yield put(unsetSending);
  }
}

export function* watchForGetProfile() {
  yield takeLatest(SAGA_GET_PROFILE, getProfile);
}
